"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var lodash_uniqby_1 = __importDefault(require("lodash.uniqby"));
var Select_1 = require("./components/Select");
var core_1 = require("@material-ui/core");
var fieldsProps_1 = require("./utils/fieldsProps");
var debounce_1 = require("debounce");
var react_intl_1 = require("react-intl");
var groupBy_1 = require("./utils/groupBy");
function TTableColumnsVisibilityFilter(props) {
    var columns = props.columns, commonGroupCode = props.commonGroupCode, commonGroupTitle = props.commonGroupTitle, setFilteredColumnCodes = props.setFilteredColumnCodes;
    var groupsData = react_1.useMemo(function () {
        return Object.fromEntries(groupBy_1.groupBy(lodash_uniqby_1.default(columns.map(function (c) { return ({
            id: c.groupCode || commonGroupCode,
            title: c.groupTitle || commonGroupTitle,
            parentId: c.bObjectTitle || '',
        }); }), function (v) { return v.id; }), function (v) { return v.parentId; }));
    }, [columns, commonGroupCode, commonGroupTitle]);
    var _a = react_1.useState([]), groups = _a[0], setGroups = _a[1];
    var handleChangeGroups = function (e, values) {
        setGroups(values);
    };
    var groupsPredicate = react_1.useCallback(function (c) { return groups.includes(c.groupCode || commonGroupCode); }, [
        groups,
    ]);
    var _b = react_1.useState(''), columnName = _b[0], setColumnName = _b[1];
    var handleChangeColumnName = function (e) {
        setColumnName(e.target.value);
    };
    var columnNamePredicate = react_1.useCallback(function (c) { return c.Header.toLocaleLowerCase().includes(columnName.toLocaleLowerCase()); }, [columnName]);
    var filterColumns = react_1.useCallback(debounce_1.debounce(function (predicate) {
        if (predicate) {
            setFilteredColumnCodes(columns.filter(predicate).map(function (c) { return c.columnCode; }));
        }
        else {
            setFilteredColumnCodes([]);
        }
    }, 500), [columns, setFilteredColumnCodes]);
    var hasGroupFilter = groups.length > 0;
    var hasColumnNameFilter = columnName.length > 0;
    react_1.useEffect(function () {
        if (hasGroupFilter && hasColumnNameFilter) {
            filterColumns(function (c) { return columnNamePredicate(c) && groupsPredicate(c); });
        }
        else if (hasGroupFilter) {
            filterColumns(groupsPredicate);
        }
        else if (hasColumnNameFilter) {
            filterColumns(columnNamePredicate);
        }
        else {
            filterColumns();
        }
    }, [
        groupsPredicate,
        columnNamePredicate,
        setFilteredColumnCodes,
        hasGroupFilter,
        hasColumnNameFilter,
        filterColumns,
    ]);
    return (react_1.default.createElement(core_1.Box, { mb: 5 },
        react_1.default.createElement(core_1.Grid, { container: true, direction: "row", spacing: 2 },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 6 },
                react_1.default.createElement(Select_1.TTableSelectForFilter, { selectData: groupsData, onChange: handleChangeGroups, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.group", defaultMessage: "\u0413\u0440\u0443\u043F\u043F\u0430" }), values: groups })),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 6 },
                react_1.default.createElement(core_1.TextField, __assign({ label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.column", defaultMessage: "\u0421\u0442\u043E\u043B\u0431\u0435\u0446" }), value: columnName, onChange: handleChangeColumnName }, fieldsProps_1.textFieldProps)))),
        !(hasColumnNameFilter || hasGroupFilter) && (react_1.default.createElement(core_1.Box, { mt: 5 },
            react_1.default.createElement(core_1.Grid, { container: true, direction: "column", alignContent: "center", justify: "center" },
                react_1.default.createElement(core_1.Grid, { item: true },
                    react_1.default.createElement(core_1.Typography, { variant: "caption" },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.noColumnFilter", defaultMessage: "\u0427\u0442\u043E\u0431\u044B \u0443\u0432\u0438\u0434\u0435\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0441\u0442\u043E\u043B\u0431\u0446\u044B, \u0432\u043E\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435\u0441\u044C \u0444\u0438\u043B\u044C\u0442\u0440\u0430\u043C\u0438 \u0432\u044B\u0448\u0435." }))))))));
}
exports.default = TTableColumnsVisibilityFilter;
